module.exports = __webpack_public_path__ + "static/media/promo11.103bb588.jpg";